module.exports = __webpack_public_path__ + "static/media/matheus-pereira.f8257be2.jpg";